import React from 'react';
import noMessagesGraphic from '../../assets/images/no-messages-graphic.svg';

interface DataTableEmptyStateProps {
  title?: string;
  message?: string | React.ReactNode;
  action?: React.ReactNode;
  isDragOver?: boolean;
  isDropZone?: boolean;
}

function DataTableEmptyState({
  title,
  message,
  action,
  isDragOver = false,
  isDropZone = false
}: Readonly<DataTableEmptyStateProps>): React.ReactElement {
  const dragOverClasses = isDragOver
    ? 'border-blue-400 bg-blue-50'
    : 'border-gray-200';
  const borderClasses = isDropZone
    ? `border-2 border-dashed ${dragOverClasses}`
    : '';

  return (
    <div
      className={`flex flex-col items-center justify-center py-16 px-4 rounded-md transition-colors duration-200 ${borderClasses}`}
    >
      <img src={noMessagesGraphic} alt='' className='w-56 h-64 mb-8' />
      <h3 className='text-xl font-semibold text-gray-900 mb-2'>
        {title || 'No data found'}
      </h3>
      <p className='text-sm text-gray-600 text-center mb-6 max-w-md'>
        {message || 'Try adjusting your search or filters'}
      </p>
      {action && <div className='mt-4'>{action}</div>}
    </div>
  );
}

export default DataTableEmptyState;
